import React from 'react'

const Quotes = () => {
  return (
    <div>
      Quotes Page
    </div>
  )
}

export default Quotes
